<template>
  <div>
    <template v-for="(component) in data">
      <component-group
        v-if="component.type == 'group'"
        :key="component.id"
        :data="component.children"
        :page="page"
        :site-data="siteData"
        :is-fixed-parent="isFixedParent"
      />
      <zeus-component
        v-else
        :key="component.id"
        :data="component"
        :page="page"
        :site-data="siteData"
        :is-fixed-parent="isFixedParent"
      />
    </template>
  </div>
</template>

<script>
import ComponentGroup from './componentGroup'
import ZeusComponent from './component'
export default {
    'name': 'ComponentGroup',
    'components': { ComponentGroup, ZeusComponent },
    'props': {
        'data': { 'type': Array },
        'page': { 'type': Object },
        'isFixedParent': { 'type': Boolean },
        'siteData': {
            'type': Object,
            'default': () => ({})
        }
    }
}
</script>
